import { Logger } from '@tiger/logger';
import devtools from '@tiger/devtools';
import { createRoot } from 'react-dom/client';
import Root from 'modules/Root';
import '@tiger/ads';
import { preloadCG } from 'utils/API';
import { IS_TUPSDK, SDK_CLIENT, SUPPORT_THEME_MAP } from 'utils/constants';

if (!__LOCAL_DEV__) {
    devtools({ smart: false, tool: 'all' });
}

if (!__DEV__) {
    // 生产环境关闭日志输出
    Logger.config({
        logLevels: []
    });
}

// 如果是TUPSDK的用户，则设置对应的theme
if (IS_TUPSDK && SDK_CLIENT) {
    if (SUPPORT_THEME_MAP[SDK_CLIENT]) {
        document.body.setAttribute('data-bs-theme', SUPPORT_THEME_MAP[SDK_CLIENT]);
    }
}

const root = createRoot(document.getElementById('wrap') as Element);

preloadCG().then(() => root.render(<Root />));
